import * as Apollo from "@apollo/client"
import { gql } from "@apollo/client"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: any; output: any }
  JSON: { input: any; output: any }
}

export type AccessoryReport = {
  __typename?: "AccessoryReport"
  report_name?: Maybe<Scalars["String"]["output"]>
  report_type?: Maybe<Scalars["String"]["output"]>
  report_url?: Maybe<Scalars["String"]["output"]>
}

export type AuthPayload = {
  __typename?: "AuthPayload"
  token: Scalars["String"]["output"]
}

export type Faq = {
  __typename?: "FAQ"
  display_order?: Maybe<Scalars["Int"]["output"]>
  faq_a?: Maybe<Scalars["String"]["output"]>
  faq_image?: Maybe<Scalars["String"]["output"]>
  faq_information_reference?: Maybe<Scalars["String"]["output"]>
  faq_q?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  is_active?: Maybe<Scalars["Boolean"]["output"]>
}

export type FmpProduct = {
  __typename?: "FMPProduct"
  application_id?: Maybe<Scalars["Int"]["output"]>
  application_name?: Maybe<Scalars["String"]["output"]>
  barrier_construction_id?: Maybe<Scalars["Int"]["output"]>
  barrier_construction_name?: Maybe<Scalars["String"]["output"]>
  barrier_thickness_mm?: Maybe<Scalars["String"]["output"]>
  barrier_type_id?: Maybe<Scalars["Int"]["output"]>
  barrier_type_name?: Maybe<Scalars["String"]["output"]>
  date_created?: Maybe<Scalars["Date"]["output"]>
  date_modified?: Maybe<Scalars["Date"]["output"]>
  fire_stopping_system_id?: Maybe<Scalars["Int"]["output"]>
  fire_stopping_system_name?: Maybe<Scalars["String"]["output"]>
  fitting?: Maybe<Scalars["Boolean"]["output"]>
  fmp_product_services?: Maybe<Scalars["String"]["output"]>
  fmp_project_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  installation_2d_drawing_url?: Maybe<Scalars["String"]["output"]>
  installation_guide_url?: Maybe<Scalars["String"]["output"]>
  installation_notes?: Maybe<Scalars["String"]["output"]>
  project_system_desc?: Maybe<Scalars["String"]["output"]>
  project_system_ref_id?: Maybe<Scalars["Int"]["output"]>
  reference_number?: Maybe<Scalars["String"]["output"]>
  report_expiry_date?: Maybe<Scalars["Date"]["output"]>
  report_id?: Maybe<Scalars["Int"]["output"]>
  report_issue_date?: Maybe<Scalars["Date"]["output"]>
  report_issuer_id?: Maybe<Scalars["Int"]["output"]>
  report_issuer_name?: Maybe<Scalars["String"]["output"]>
  report_name?: Maybe<Scalars["String"]["output"]>
  report_reference_number?: Maybe<Scalars["String"]["output"]>
  report_type_id?: Maybe<Scalars["Int"]["output"]>
  report_type_name?: Maybe<Scalars["String"]["output"]>
  system_frl?: Maybe<Scalars["String"]["output"]>
}

export type FmpProductEntryInput = {
  fmp_product_id: Scalars["Int"]["input"]
  fmp_project_id: Scalars["Int"]["input"]
  project_system_desc?: InputMaybe<Scalars["String"]["input"]>
  project_system_ref?: InputMaybe<Scalars["String"]["input"]>
  system_frl?: InputMaybe<Scalars["String"]["input"]>
  user_id: Scalars["Int"]["input"]
}

export type FmpProductInput = {
  fmp_project_id: Scalars["Int"]["input"]
  system_id: Array<InputMaybe<Scalars["Int"]["input"]>>
  user_id: Scalars["Int"]["input"]
}

export type FmpProductOrder = {
  id: Scalars["Int"]["input"]
  serial_no: Scalars["Int"]["input"]
}

export type FmpProductService = {
  __typename?: "FMPProductService"
  date_created?: Maybe<Scalars["Date"]["output"]>
  date_modified?: Maybe<Scalars["Date"]["output"]>
  fmp_product_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  service_category_id?: Maybe<Scalars["Int"]["output"]>
  service_category_name?: Maybe<Scalars["String"]["output"]>
  service_id?: Maybe<Scalars["Int"]["output"]>
  service_size?: Maybe<Scalars["String"]["output"]>
  system_id?: Maybe<Scalars["Int"]["output"]>
}

export type FmpProject = {
  __typename?: "FMPProject"
  date_created?: Maybe<Scalars["String"]["output"]>
  date_modified?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  project_address?: Maybe<Scalars["String"]["output"]>
  project_name?: Maybe<Scalars["String"]["output"]>
  revision?: Maybe<Scalars["String"]["output"]>
  subcontractor_address?: Maybe<Scalars["String"]["output"]>
  subcontractor_logo?: Maybe<Scalars["String"]["output"]>
  subcontractor_name?: Maybe<Scalars["String"]["output"]>
  systems?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  user_id?: Maybe<Scalars["Int"]["output"]>
}

export type FmpProjectInput = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  is_archived?: InputMaybe<Scalars["Boolean"]["input"]>
  project_address?: InputMaybe<Scalars["String"]["input"]>
  project_name?: InputMaybe<Scalars["String"]["input"]>
  revision?: InputMaybe<Scalars["String"]["input"]>
  subcontractor_address?: InputMaybe<Scalars["String"]["input"]>
  subcontractor_logo?: InputMaybe<Scalars["String"]["input"]>
  subcontractor_name?: InputMaybe<Scalars["String"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type HomePageTile = {
  __typename?: "HomePageTile"
  id?: Maybe<Scalars["Int"]["output"]>
  tileDate?: Maybe<Scalars["Date"]["output"]>
  tileDescription?: Maybe<Scalars["String"]["output"]>
  tileImageURL?: Maybe<Scalars["String"]["output"]>
  tileRedirectURL?: Maybe<Scalars["String"]["output"]>
  tileTitle?: Maybe<Scalars["String"]["output"]>
}

export type Instruction = {
  __typename?: "Instruction"
  files?: Maybe<Array<Maybe<Report>>>
  installation_type?: Maybe<Scalars["String"]["output"]>
}

export type InstructionReport = {
  __typename?: "InstructionReport"
  reportName: Scalars["String"]["output"]
  reportURL?: Maybe<Scalars["String"]["output"]>
}

export type Mutation = {
  __typename?: "Mutation"
  addToFMPProject?: Maybe<Scalars["String"]["output"]>
  archiveFMPProject?: Maybe<Scalars["String"]["output"]>
  copyFMPProject?: Maybe<Scalars["String"]["output"]>
  createFMPProject?: Maybe<Scalars["JSON"]["output"]>
  deleteFMPProject?: Maybe<Scalars["String"]["output"]>
  deleteProfile?: Maybe<Scalars["String"]["output"]>
  downloadFMPReports?: Maybe<Scalars["String"]["output"]>
  editFMPProductEntry?: Maybe<Scalars["String"]["output"]>
  emailEnquiry?: Maybe<Scalars["JSON"]["output"]>
  exportFMPToExcel?: Maybe<Scalars["String"]["output"]>
  loginUser?: Maybe<AuthPayload>
  logoutUser?: Maybe<Scalars["String"]["output"]>
  reOrderFMPProducts?: Maybe<Scalars["String"]["output"]>
  removeFromFMPProject?: Maybe<Scalars["String"]["output"]>
  resendVerificationLink?: Maybe<Scalars["JSON"]["output"]>
  sendResetPasswordLink?: Maybe<Scalars["JSON"]["output"]>
  signup?: Maybe<Scalars["JSON"]["output"]>
  updateFMPProject?: Maybe<Scalars["JSON"]["output"]>
  updatePassword?: Maybe<Scalars["JSON"]["output"]>
  updateProfile?: Maybe<Scalars["JSON"]["output"]>
  verifyEmail?: Maybe<Scalars["JSON"]["output"]>
}

export type MutationAddToFmpProjectArgs = {
  input?: InputMaybe<FmpProductInput>
}

export type MutationArchiveFmpProjectArgs = {
  archive?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type MutationCopyFmpProjectArgs = {
  id: Scalars["Int"]["input"]
  project_name: Scalars["String"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type MutationCreateFmpProjectArgs = {
  input?: InputMaybe<FmpProjectInput>
}

export type MutationDeleteFmpProjectArgs = {
  id: Scalars["Int"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type MutationDeleteProfileArgs = {
  user_id: Scalars["Int"]["input"]
}

export type MutationDownloadFmpReportsArgs = {
  html?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  option: Scalars["Int"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type MutationEditFmpProductEntryArgs = {
  input?: InputMaybe<FmpProductEntryInput>
}

export type MutationEmailEnquiryArgs = {
  input?: InputMaybe<InquiryInput>
}

export type MutationExportFmpToExcelArgs = {
  id: Scalars["Int"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type MutationLoginUserArgs = {
  password: Scalars["String"]["input"]
  username: Scalars["String"]["input"]
}

export type MutationLogoutUserArgs = {
  user_id: Scalars["Int"]["input"]
}

export type MutationReOrderFmpProductsArgs = {
  fmp_project_id: Scalars["Int"]["input"]
  input?: InputMaybe<Array<InputMaybe<FmpProductOrder>>>
  user_id: Scalars["Int"]["input"]
}

export type MutationRemoveFromFmpProjectArgs = {
  input?: InputMaybe<FmpProductInput>
}

export type MutationResendVerificationLinkArgs = {
  email_address: Scalars["String"]["input"]
}

export type MutationSendResetPasswordLinkArgs = {
  email_address: Scalars["String"]["input"]
}

export type MutationSignupArgs = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  company_logo?: InputMaybe<Scalars["String"]["input"]>
  company_name?: InputMaybe<Scalars["String"]["input"]>
  email_address: Scalars["String"]["input"]
  first_name: Scalars["String"]["input"]
  last_name?: InputMaybe<Scalars["String"]["input"]>
  password: Scalars["String"]["input"]
  pincode?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  suburb?: InputMaybe<Scalars["String"]["input"]>
  supplier?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationUpdateFmpProjectArgs = {
  input?: InputMaybe<FmpProjectInput>
}

export type MutationUpdatePasswordArgs = {
  new_password: Scalars["String"]["input"]
  token: Scalars["String"]["input"]
}

export type MutationUpdateProfileArgs = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  company_logo?: InputMaybe<Scalars["String"]["input"]>
  company_name?: InputMaybe<Scalars["String"]["input"]>
  email_address?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  new_email_address?: InputMaybe<Scalars["String"]["input"]>
  new_password?: InputMaybe<Scalars["String"]["input"]>
  password?: InputMaybe<Scalars["String"]["input"]>
  pincode?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  suburb?: InputMaybe<Scalars["String"]["input"]>
  supplier?: InputMaybe<Scalars["String"]["input"]>
  user_id: Scalars["Int"]["input"]
}

export type MutationVerifyEmailArgs = {
  token: Scalars["String"]["input"]
}

export type Product4Menu = {
  __typename?: "Product4Menu"
  category?: Maybe<Scalars["String"]["output"]>
  pid?: Maybe<Scalars["String"]["output"]>
  prod_code?: Maybe<Scalars["String"]["output"]>
  prod_link?: Maybe<Scalars["String"]["output"]>
  prod_photo?: Maybe<Scalars["String"]["output"]>
  subcategory?: Maybe<Scalars["String"]["output"]>
  sub_category_description?: Maybe<Scalars["String"]["output"]>
}

export type ProductAccessoryReport = {
  __typename?: "ProductAccessoryReport"
  docs?: Maybe<Array<Maybe<AccessoryReport>>>
  product_code?: Maybe<Scalars["String"]["output"]>
}

export type ProductDocs = {
  __typename?: "ProductDocs"
  display_order?: Maybe<Scalars["Int"]["output"]>
  document_type?: Maybe<Scalars["String"]["output"]>
  document_type_id?: Maybe<Scalars["Int"]["output"]>
  document_url?: Maybe<Scalars["String"]["output"]>
  thumbnail_url?: Maybe<Scalars["String"]["output"]>
}

export type ProductElement = {
  __typename?: "ProductElement"
  element_name: Scalars["String"]["output"]
  services_grp?: Maybe<Array<Maybe<ProductService>>>
}

export type ProductFilterInput = {
  element_display_1?: InputMaybe<Scalars["String"]["input"]>
  element_display_2?: InputMaybe<Scalars["String"]["input"]>
  element_type_id?: InputMaybe<Scalars["String"]["input"]>
  fitting_allowed?: InputMaybe<Scalars["String"]["input"]>
  frl?: InputMaybe<Scalars["String"]["input"]>
  industry_category_id?: InputMaybe<Scalars["String"]["input"]>
  installation_type_id?: InputMaybe<Scalars["String"]["input"]>
  product_generic_code?: InputMaybe<Scalars["String"]["input"]>
  product_type_id?: InputMaybe<Scalars["String"]["input"]>
  service_size?: InputMaybe<Scalars["String"]["input"]>
  service_sub_cat_id?: InputMaybe<Scalars["String"]["input"]>
  service_type_id?: InputMaybe<Scalars["String"]["input"]>
}

export type ProductReport = {
  __typename?: "ProductReport"
  report_name: Scalars["String"]["output"]
  report_url?: Maybe<Scalars["String"]["output"]>
  is_public?: Maybe<Scalars["Boolean"]["output"]>
}

export type ProductService = {
  __typename?: "ProductService"
  rep_grp?: Maybe<Array<Maybe<ProductReport>>>
  service_name?: Maybe<Scalars["String"]["output"]>
  service_notes?: Maybe<Array<Maybe<Array<Maybe<Scalars["String"]["output"]>>>>>
  service_size?: Maybe<Scalars["String"]["output"]>
  system_frl?: Maybe<Scalars["String"]["output"]>
}

export type ProductServicesResponse = {
  __typename?: "ProductServicesResponse"
  data?: Maybe<Array<Maybe<ProductSystems>>>
  header?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type ProductSystems = {
  __typename?: "ProductSystems"
  application?: Maybe<Scalars["String"]["output"]>
  element_grp?: Maybe<Array<Maybe<ProductElement>>>
  pid: Scalars["String"]["output"]
}

export type ProductTable = {
  __typename?: "ProductTable"
  bd?: Maybe<Scalars["String"]["output"]>
  category_name?: Maybe<Scalars["String"]["output"]>
  doc_grp?: Maybe<Array<Maybe<ProductDocs>>>
  generic_code?: Maybe<Scalars["String"]["output"]>
  ht?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  ind?: Maybe<Scalars["String"]["output"]>
  installation_type?: Maybe<Scalars["String"]["output"]>
  installation_type_id?: Maybe<Scalars["Int"]["output"]>
  nsz?: Maybe<Scalars["String"]["output"]>
  papplications?: Maybe<Scalars["String"]["output"]>
  pelements?: Maybe<Scalars["String"]["output"]>
  product_category_id?: Maybe<Scalars["Int"]["output"]>
  product_code?: Maybe<Scalars["String"]["output"]>
  product_desc?: Maybe<Scalars["String"]["output"]>
  product_qr_url?: Maybe<Scalars["String"]["output"]>
  product_url?: Maybe<Scalars["String"]["output"]>
  pservices?: Maybe<Scalars["String"]["output"]>
  thick?: Maybe<Scalars["String"]["output"]>
  wd?: Maybe<Scalars["String"]["output"]>
}

export type QualityCertificate = {
  __typename?: "QualityCertificate"
  certificate_name?: Maybe<Scalars["String"]["output"]>
  certificate_url?: Maybe<Scalars["String"]["output"]>
}

export type Query = {
  __typename?: "Query"
  allCollars?: Maybe<Array<Maybe<Product4Menu>>>
  collarAccessories?: Maybe<Scalars["JSON"]["output"]>
  faqs?: Maybe<Array<Maybe<Faq>>>
  filterProduct?: Maybe<Scalars["JSON"]["output"]>
  frlStandards?: Maybe<Scalars["JSON"]["output"]>
  getCertificateReport?: Maybe<Report>
  getHomePageTiles?: Maybe<Array<Maybe<HomePageTile>>>
  getInstallationInstructionReport?: Maybe<Report>
  getProductFilterCriteriaMaster?: Maybe<Scalars["JSON"]["output"]>
  getQualityCertificates?: Maybe<Array<Maybe<QualityCertificate>>>
  getReport?: Maybe<Report>
  productByCode?: Maybe<ProductTable>
  productByID?: Maybe<ProductTable>
  productInstallationInstructions?: Maybe<Array<Maybe<Instruction>>>
  productMenu?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>
  productServicesByCode?: Maybe<ProductServicesResponse>
  productServicesByID?: Maybe<ProductServicesResponse>
  reportDetails?: Maybe<Array<Maybe<FlatReport>>>
  viewFMPProduct?: Maybe<Scalars["JSON"]["output"]>
  viewFMPProject?: Maybe<Scalars["JSON"]["output"]>
  viewProfile?: Maybe<UserProfile>
  viewUserArchivedFMPs?: Maybe<Array<Maybe<FmpProject>>>
  viewUserFMPs?: Maybe<Array<Maybe<FmpProject>>>
}

export type QueryAllCollarsArgs = {
  collarTypeID: Scalars["String"]["input"]
}

export type QueryCollarAccessoriesArgs = {
  subCategory: Scalars["String"]["input"]
}

export type QueryFilterProductArgs = {
  criteria?: InputMaybe<ProductFilterInput>
}

export type QueryGetCertificateReportArgs = {
  certificateName: Scalars["String"]["input"]
}

export type QueryGetInstallationInstructionReportArgs = {
  instruction: Scalars["String"]["input"]
}

export type QueryGetProductFilterCriteriaMasterArgs = {
  criteria?: InputMaybe<ProductFilterInput>
}

export type QueryGetReportArgs = {
  report_no: Scalars["String"]["input"]
}

export type QueryProductByCodeArgs = {
  productCode: Scalars["String"]["input"]
}

export type QueryProductByIdArgs = {
  id: Scalars["Int"]["input"]
}

export type QueryProductMenuArgs = {
  category: Scalars["Int"]["input"]
}

export type QueryProductServicesByCodeArgs = {
  productCode: Scalars["String"]["input"]
}

export type QueryProductServicesByIdArgs = {
  id: Scalars["Int"]["input"]
}

export type QueryViewFmpProductArgs = {
  fmp_product_id: Scalars["Int"]["input"]
  fmp_project_id: Scalars["Int"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type QueryViewFmpProjectArgs = {
  fmp_project_id: Scalars["Int"]["input"]
  user_id: Scalars["Int"]["input"]
}

export type QueryViewProfileArgs = {
  user_id: Scalars["Int"]["input"]
}

export type QueryViewUserArchivedFmPsArgs = {
  user_id: Scalars["Int"]["input"]
}

export type QueryViewUserFmPsArgs = {
  user_id: Scalars["Int"]["input"]
}

export type FlatReport = {
  __typename?: "FlatReport"
  reportNo?: Maybe<Scalars["String"]["output"]>
  reportURL?: Maybe<Scalars["String"]["output"]>
  fileName?: Maybe<Scalars["String"]["output"]>
  reportTypeId?: Maybe<Scalars["Int"]["output"]>
  isPublic?: Maybe<Scalars["Boolean"]["output"]>
}

export type Report = {
  __typename?: "Report"
  reportName: Scalars["String"]["output"]
  reportURL?: Maybe<Scalars["String"]["output"]>
  downloadURL?: Maybe<Scalars["String"]["output"]>
  fileName?: Maybe<Scalars["String"]["output"]>
}

export type ReportPageData = {
  __typename?: "ReportPageData"
  productCat: Scalars["String"]["output"]
  reportTypeReports?: Maybe<Array<Maybe<ReportTypeReport>>>
}

export type ReportTypeReport = {
  __typename?: "ReportTypeReport"
  reportType: Scalars["String"]["output"]
  reports?: Maybe<Array<Maybe<Report>>>
}

export type User = {
  __typename?: "User"
  email: Scalars["String"]["output"]
  username?: Maybe<Scalars["String"]["output"]>
}

export type UserProfile = {
  __typename?: "UserProfile"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  company_logo?: Maybe<Scalars["String"]["output"]>
  company_name: Scalars["String"]["output"]
  email_address: Scalars["String"]["output"]
  first_name: Scalars["String"]["output"]
  last_name: Scalars["String"]["output"]
  pincode?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  suburb?: Maybe<Scalars["String"]["output"]>
  supplier?: Maybe<Scalars["String"]["output"]>
  user_id: Scalars["String"]["output"]
}

export type InquiryInput = {
  contact_preference?: InputMaybe<Scalars["String"]["input"]>
  content?: InputMaybe<Scalars["String"]["input"]>
  emailAddress?: InputMaybe<Scalars["String"]["input"]>
  inquiry_type?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
}

export type AllCollarsQueryVariables = Exact<{
  collarTypeId: Scalars["String"]["input"]
}>

export type AllCollarsQuery = {
  __typename?: "Query"
  allCollars?: Array<{
    __typename?: "Product4Menu"
    pid?: string | null
    prod_code?: string | null
    prod_photo?: string | null
    category?: string | null
    subcategory?: string | null
    sub_category_description?: string | null
    prod_link?: string | null
  } | null> | null
}

export type GetHomePageTilesQueryVariables = Exact<{ [key: string]: never }>

export type GetHomePageTilesQuery = {
  __typename?: "Query"
  getHomePageTiles?: Array<{
    __typename?: "HomePageTile"
    id?: number | null
    tileDate?: any | null
    tileDescription?: string | null
    tileImageURL?: string | null
    tileRedirectURL?: string | null
    tileTitle?: string | null
  } | null> | null
}

export type ProductByIdQueryVariables = Exact<{
  productByIdId: Scalars["Int"]["input"]
}>

export type ProductByIdQuery = {
  __typename?: "Query"
  productByID?: {
    __typename?: "ProductTable"
    product_code?: string | null
    product_desc?: string | null
    generic_code?: string | null
    product_category_id?: number | null
    category_name?: string | null
    installation_type_id?: number | null
    installation_type?: string | null
    nsz?: string | null
    ht?: string | null
    wd?: string | null
    thick?: string | null
    bd?: string | null
    ind?: string | null
    product_url?: string | null
    product_qr_url?: string | null
    pelements?: string | null
    papplications?: string | null
    pservices?: string | null
    doc_grp?: Array<{
      __typename?: "ProductDocs"
      document_url?: string | null
      document_type_id?: number | null
      document_type?: string | null
      display_order?: number | null
    } | null> | null
  } | null
}

export type ProductInstallationInstructionsQueryVariables = Exact<{ [key: string]: never }>

export type ProductInstallationInstructionsQuery = {
  __typename?: "Query"
  productInstallationInstructions?: Array<{
    __typename?: "Instruction"
    installation_type?: string | null
    files?: Array<{ __typename?: "Report"; reportName: string; reportURL?: string | null } | null> | null
  } | null> | null
}

export type GetQualityCertificatesQueryVariables = Exact<{ [key: string]: never }>

export type GetQualityCertificatesQuery = {
  __typename?: "Query"
  getQualityCertificates?: Array<{
    __typename?: "QualityCertificate"
    certificate_name?: string | null
    certificate_url?: string | null
    file_name?: string | null
  } | null> | null
}

export type ProductServicesByIdQueryVariables = Exact<{
  productServicesByIdId: Scalars["Int"]["input"]
}>

export type ProductServicesByIdQuery = {
  __typename?: "Query"
  productServicesByID?: {
    __typename?: "ProductServicesResponse"
    header?: Array<string | null> | null
    data?: Array<{
      __typename?: "ProductSystems"
      pid: string
      application?: string | null
      element_grp?: Array<{
        __typename?: "ProductElement"
        element_name: string
        services_grp?: Array<{
          __typename?: "ProductService"
          service_name?: string | null
          service_size?: string | null
          system_frl?: string | null
          service_notes?: Array<Array<string | null> | null> | null
          rep_grp?: Array<{ __typename?: "ProductReport"; report_name: string; report_url?: string | null; is_public?: boolean | null } | null> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type GetProductFilterCriteriaMasterQueryVariables = Exact<{
  criteria?: InputMaybe<ProductFilterInput>
}>

export type GetProductFilterCriteriaMasterQuery = { __typename?: "Query"; getProductFilterCriteriaMaster?: any | null }

export type ViewProfileQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type ViewProfileQuery = {
  __typename?: "Query"
  viewProfile?: {
    __typename?: "UserProfile"
    user_id: string
    first_name: string
    last_name: string
    email_address: string
    company_name: string
    address1?: string | null
    address2?: string | null
    suburb?: string | null
    city?: string | null
    state?: string | null
    pincode?: string | null
    company_logo?: string | null
    supplier?: string | null
  } | null
}

export type ViewUserFmPsQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type ViewUserFmPsQuery = {
  __typename?: "Query"
  viewUserFMPs?: Array<{
    __typename?: "FMPProject"
    id?: number | null
    user_id?: number | null
    project_name?: string | null
    project_address?: string | null
    subcontractor_name?: string | null
    subcontractor_address?: string | null
    subcontractor_logo?: string | null
    revision?: string | null
    date_created?: string | null
    date_modified?: string | null
    systems?: Array<number | null> | null
  } | null> | null
}

export type ViewUserArchivedFmPsQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type ViewUserArchivedFmPsQuery = {
  __typename?: "Query"
  viewUserArchivedFMPs?: Array<{
    __typename?: "FMPProject"
    id?: number | null
    user_id?: number | null
    project_name?: string | null
    project_address?: string | null
    subcontractor_name?: string | null
    subcontractor_address?: string | null
    subcontractor_logo?: string | null
    revision?: string | null
    date_created?: string | null
    date_modified?: string | null
    systems?: Array<number | null> | null
  } | null> | null
}

export type GetProductMenuQueryVariables = Exact<{
  category: Scalars["Int"]["input"]
}>

export type GetProductMenuQuery = { __typename?: "Query"; productMenu?: Array<any | null> | null }

export type ProductByCodeQueryVariables = Exact<{
  productCode: Scalars["String"]["input"]
}>

export type ProductByCodeQuery = {
  __typename?: "Query"
  productByCode?: {
    __typename?: "ProductTable"
    id?: number | null
    product_code?: string | null
    product_desc?: string | null
    generic_code?: string | null
    product_category_id?: number | null
    category_name?: string | null
    installation_type_id?: number | null
    installation_type?: string | null
    nsz?: string | null
    ht?: string | null
    wd?: string | null
    thick?: string | null
    bd?: string | null
    ind?: string | null
    product_url?: string | null
    product_qr_url?: string | null
    pelements?: string | null
    papplications?: string | null
    pservices?: string | null
    doc_grp?: Array<{
      __typename?: "ProductDocs"
      document_url?: string | null
      document_type_id?: number | null
      document_type?: string | null
      display_order?: number | null
      thumbnail_url?: string | null
    } | null> | null
  } | null
}

export type ProductServicesByCodeQueryVariables = Exact<{
  productCode: Scalars["String"]["input"]
}>

export type ProductServicesByCodeQuery = {
  __typename?: "Query"
  productServicesByCode?: {
    __typename?: "ProductServicesResponse"
    header?: Array<string | null> | null
    data?: Array<{
      __typename?: "ProductSystems"
      pid: string
      application?: string | null
      element_grp?: Array<{
        __typename?: "ProductElement"
        element_name: string
        services_grp?: Array<{
          __typename?: "ProductService"
          system_frl?: string | null
          service_name?: string | null
          service_notes?: Array<Array<string | null> | null> | null
          service_size?: string | null
          rep_grp?: Array<{ __typename?: "ProductReport"; report_name: string; report_url?: string | null; is_public?: boolean | null } | null> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type ReportPageDetailsQueryVariables = Exact<{ [key: string]: never }>

export type ReportPageDetailsQuery = {
  __typename?: "Query"
  reportDetails?: Array<{
    __typename?: "FlatReport"
    reportNo?: string | null
    reportURL?: string | null
    fileName?: string | null
    reportTypeId?: number | null
    isPublic?: boolean | null
  } | null> | null
}

export type GetReportQueryVariables = Exact<{
  reportNo: Scalars["String"]["input"]
}>

export type GetReportQuery = { __typename?: "Query"; getReport?: { __typename?: "Report"; reportName: string; reportURL?: string | null; downloadURL?: string | null; fileName?: string | null } | null }

export type GetInstallationInstructionReportQueryVariables = Exact<{
  instruction: Scalars["String"]["input"]
}>

export type GetInstallationInstructionReportQuery = {
  __typename?: "Query"
  getInstallationInstructionReport?: { __typename?: "Report"; reportName: string; reportURL?: string | null; downloadURL?: string | null; fileName?: string | null } | null
}

export type GetCertificateReportQueryVariables = Exact<{
  certificateName: Scalars["String"]["input"]
}>

export type GetCertificateReportQuery = {
  __typename?: "Query"
  getCertificateReport?: { __typename?: "Report"; reportName: string; reportURL?: string | null; fileName?: string | null } | null
}

export type FilterProductQueryVariables = Exact<{
  criteria?: InputMaybe<ProductFilterInput>
}>

export type FilterProductQuery = { __typename?: "Query"; filterProduct?: any | null }

export type GetFmpSystemsProductsQueryVariables = Exact<{
  systemIds: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type GetFmpSystemsProductsQuery = { __typename?: "Query"; getFmpSystemsProducts?: any | null }

export type ViewFmpProjectQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
  fmpProjectId: Scalars["Int"]["input"]
}>

export type ViewFmpProjectQuery = { __typename?: "Query"; viewFMPProject?: any | null }

export type ViewFmpProductQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
  fmpProjectId: Scalars["Int"]["input"]
  fmpProductId: Scalars["Int"]["input"]
}>

export type ViewFmpProductQuery = { __typename?: "Query"; viewFMPProduct?: any | null }

export type FaqsQueryVariables = Exact<{ [key: string]: never }>

export type FaqsQuery = {
  __typename?: "Query"
  faqs?: Array<{
    __typename?: "FAQ"
    id?: string | null
    faq_q?: string | null
    faq_a?: string | null
    faq_image?: string | null
    faq_information_reference?: string | null
    display_order?: number | null
  } | null> | null
}

export type FrlStandardsQueryVariables = Exact<{ [key: string]: never }>

export type FrlStandardsQuery = { __typename?: "Query"; frlStandards?: any | null }

export type LogoutUserMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type LogoutUserMutation = { __typename?: "Mutation"; logoutUser?: string | null }

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars["String"]["input"]
}>

export type VerifyEmailMutation = { __typename?: "Mutation"; verifyEmail?: any | null }

export type ResendVerificationLinkMutationVariables = Exact<{
  email_address: Scalars["String"]["input"]
}>

export type ResendVerificationLinkMutation = { __typename?: "Mutation"; resendVerificationLink?: any | null }

export type CreateFmpProjectMutationVariables = Exact<{
  input?: InputMaybe<FmpProjectInput>
}>

export type CreateFmpProjectMutation = { __typename?: "Mutation"; createFMPProject?: any | null }

export type DeleteFmpProjectMutationVariables = Exact<{
  deleteFmpProjectId: Scalars["Int"]["input"]
  deleteFmpProjectUserId: Scalars["Int"]["input"]
}>

export type DeleteFmpProjectMutation = { __typename?: "Mutation"; deleteFMPProject?: string | null }

export type ArchiveFmpProjectMutationVariables = Exact<{
  archiveFmpProjectId: Scalars["Int"]["input"]
  archiveFmpProjectUserId: Scalars["Int"]["input"]
  archive?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type ArchiveFmpProjectMutation = { __typename?: "Mutation"; archiveFMPProject?: string | null }

export type AddToFmpProjectMutationVariables = Exact<{
  input?: InputMaybe<FmpProductInput>
}>

export type AddToFmpProjectMutation = { __typename?: "Mutation"; addToFMPProject?: string | null }

export type UpdateFmpProjectMutationVariables = Exact<{
  input?: InputMaybe<FmpProjectInput>
}>

export type UpdateFmpProjectMutation = { __typename?: "Mutation"; updateFMPProject?: any | null }

export type RemoveFromFmpProjectMutationVariables = Exact<{
  input?: InputMaybe<FmpProductInput>
}>

export type RemoveFromFmpProjectMutation = { __typename?: "Mutation"; removeFromFMPProject?: string | null }

export type CopyFmpProjectMutationVariables = Exact<{
  copyFmpProjectId: Scalars["Int"]["input"]
  userId: Scalars["Int"]["input"]
  projectName: Scalars["String"]["input"]
}>

export type CopyFmpProjectMutation = { __typename?: "Mutation"; copyFMPProject?: string | null }

export type EditFmpProductEntryMutationVariables = Exact<{
  input?: InputMaybe<FmpProductEntryInput>
}>

export type EditFmpProductEntryMutation = { __typename?: "Mutation"; editFMPProductEntry?: string | null }

export type DownloadFmpReportsMutationVariables = Exact<{
  downloadFmpReportsId: Scalars["Int"]["input"]
  userId: Scalars["Int"]["input"]
  html: Scalars["String"]["input"]
  option: Scalars["Int"]["input"]
}>

export type DownloadFmpReportsMutation = { __typename?: "Mutation"; downloadFMPReports?: string | null }

export type ExportFmpToExcelMutationVariables = Exact<{
  exportFmpToExcelId: Scalars["Int"]["input"]
  userId: Scalars["Int"]["input"]
}>

export type ExportFmpToExcelMutation = { __typename?: "Mutation"; exportFMPToExcel?: string | null }

export type ReOrderFmpProductsMutationVariables = Exact<{
  fmpProjectId: Scalars["Int"]["input"]
  userId: Scalars["Int"]["input"]
  input?: InputMaybe<Array<InputMaybe<FmpProductOrder>> | InputMaybe<FmpProductOrder>>
}>

export type ReOrderFmpProductsMutation = { __typename?: "Mutation"; reOrderFMPProducts?: string | null }

export const AllCollarsDocument = gql`
  query AllCollars($collarTypeId: String!) {
    allCollars(collarTypeID: $collarTypeId) {
      pid
      prod_code
      prod_photo
      category
      subcategory
      sub_category_description
      prod_link
    }
  }
`

/**
 * __useAllCollarsQuery__
 *
 * To run a query within a React component, call `useAllCollarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCollarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCollarsQuery({
 *   variables: {
 *      collarTypeId: // value for 'collarTypeId'
 *   },
 * });
 */
export function useAllCollarsQuery(baseOptions: Apollo.QueryHookOptions<AllCollarsQuery, AllCollarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AllCollarsQuery, AllCollarsQueryVariables>(AllCollarsDocument, options)
}
export function useAllCollarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCollarsQuery, AllCollarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AllCollarsQuery, AllCollarsQueryVariables>(AllCollarsDocument, options)
}
export function useAllCollarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCollarsQuery, AllCollarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AllCollarsQuery, AllCollarsQueryVariables>(AllCollarsDocument, options)
}
export type AllCollarsQueryHookResult = ReturnType<typeof useAllCollarsQuery>
export type AllCollarsLazyQueryHookResult = ReturnType<typeof useAllCollarsLazyQuery>
export type AllCollarsSuspenseQueryHookResult = ReturnType<typeof useAllCollarsSuspenseQuery>
export type AllCollarsQueryResult = Apollo.QueryResult<AllCollarsQuery, AllCollarsQueryVariables>
export const GetHomePageTilesDocument = gql`
  query GetHomePageTiles {
    getHomePageTiles {
      id
      tileDate
      tileDescription
      tileImageURL
      tileRedirectURL
      tileTitle
    }
  }
`

/**
 * __useGetHomePageTilesQuery__
 *
 * To run a query within a React component, call `useGetHomePageTilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomePageTilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomePageTilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomePageTilesQuery(baseOptions?: Apollo.QueryHookOptions<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>(GetHomePageTilesDocument, options)
}
export function useGetHomePageTilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>(GetHomePageTilesDocument, options)
}
export function useGetHomePageTilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>(GetHomePageTilesDocument, options)
}
export type GetHomePageTilesQueryHookResult = ReturnType<typeof useGetHomePageTilesQuery>
export type GetHomePageTilesLazyQueryHookResult = ReturnType<typeof useGetHomePageTilesLazyQuery>
export type GetHomePageTilesSuspenseQueryHookResult = ReturnType<typeof useGetHomePageTilesSuspenseQuery>
export type GetHomePageTilesQueryResult = Apollo.QueryResult<GetHomePageTilesQuery, GetHomePageTilesQueryVariables>
export const ProductByIdDocument = gql`
  query ProductByID($productByIdId: Int!) {
    productByID(id: $productByIdId) {
      product_code
      product_desc
      generic_code
      product_category_id
      category_name
      installation_type_id
      installation_type
      nsz
      ht
      wd
      thick
      bd
      ind
      product_url
      product_qr_url
      pelements
      papplications
      pservices
      doc_grp {
        document_url
        document_type_id
        document_type
        display_order
      }
    }
  }
`

/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      productByIdId: // value for 'productByIdId'
 *   },
 * });
 */
export function useProductByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options)
}
export function useProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options)
}
export function useProductByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options)
}
export type ProductByIdQueryHookResult = ReturnType<typeof useProductByIdQuery>
export type ProductByIdLazyQueryHookResult = ReturnType<typeof useProductByIdLazyQuery>
export type ProductByIdSuspenseQueryHookResult = ReturnType<typeof useProductByIdSuspenseQuery>
export type ProductByIdQueryResult = Apollo.QueryResult<ProductByIdQuery, ProductByIdQueryVariables>
export const ProductInstallationInstructionsDocument = gql`
  query ProductInstallationInstructions {
    productInstallationInstructions {
      installation_type
      files {
        reportName
        reportURL
      }
    }
  }
`

/**
 * __useProductInstallationInstructionsQuery__
 *
 * To run a query within a React component, call `useProductInstallationInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInstallationInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInstallationInstructionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductInstallationInstructionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProductInstallationInstructionsQuery, ProductInstallationInstructionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductInstallationInstructionsQuery, ProductInstallationInstructionsQueryVariables>(
    ProductInstallationInstructionsDocument,
    options
  )
}
export function useProductInstallationInstructionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductInstallationInstructionsQuery, ProductInstallationInstructionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductInstallationInstructionsQuery, ProductInstallationInstructionsQueryVariables>(
    ProductInstallationInstructionsDocument,
    options
  )
}
export function useProductInstallationInstructionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProductInstallationInstructionsQuery, ProductInstallationInstructionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductInstallationInstructionsQuery, ProductInstallationInstructionsQueryVariables>(
    ProductInstallationInstructionsDocument,
    options
  )
}
export type ProductInstallationInstructionsQueryHookResult = ReturnType<typeof useProductInstallationInstructionsQuery>
export type ProductInstallationInstructionsLazyQueryHookResult = ReturnType<typeof useProductInstallationInstructionsLazyQuery>
export type ProductInstallationInstructionsSuspenseQueryHookResult = ReturnType<typeof useProductInstallationInstructionsSuspenseQuery>
export type ProductInstallationInstructionsQueryResult = Apollo.QueryResult<
  ProductInstallationInstructionsQuery,
  ProductInstallationInstructionsQueryVariables
>
export const GetQualityCertificatesDocument = gql`
  query GetQualityCertificates {
    getQualityCertificates {
      certificate_name
      certificate_url
      file_name
    }
  }
`

/**
 * __useGetQualityCertificatesQuery__
 *
 * To run a query within a React component, call `useGetQualityCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQualityCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQualityCertificatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQualityCertificatesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>(GetQualityCertificatesDocument, options)
}
export function useGetQualityCertificatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>(GetQualityCertificatesDocument, options)
}
export function useGetQualityCertificatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>(GetQualityCertificatesDocument, options)
}
export type GetQualityCertificatesQueryHookResult = ReturnType<typeof useGetQualityCertificatesQuery>
export type GetQualityCertificatesLazyQueryHookResult = ReturnType<typeof useGetQualityCertificatesLazyQuery>
export type GetQualityCertificatesSuspenseQueryHookResult = ReturnType<typeof useGetQualityCertificatesSuspenseQuery>
export type GetQualityCertificatesQueryResult = Apollo.QueryResult<GetQualityCertificatesQuery, GetQualityCertificatesQueryVariables>

export type ProductDrawing = {
  __typename?: "ProductDrawing"
  product_code?: Maybe<Scalars["String"]["output"]>
  pdf_url?: Maybe<Scalars["String"]["output"]>
  revit_url?: Maybe<Scalars["String"]["output"]>
  pdf_file_name?: Maybe<Scalars["String"]["output"]>
  revit_file_name?: Maybe<Scalars["String"]["output"]>
  pdf_download_url?: Maybe<Scalars["String"]["output"]>
}

export type GetProductDrawingsQueryVariables = Exact<{ [key: string]: never }>

export type GetProductDrawingsQuery = {
  __typename?: "Query"
  getProductDrawings?: Array<{
    __typename?: "ProductDrawing"
    product_code?: string | null
    pdf_url?: string | null
    revit_url?: string | null
    pdf_file_name?: string | null
    revit_file_name?: string | null
    pdf_download_url?: string | null
  } | null> | null
}

export const GetProductDrawingsDocument = gql`
  query GetProductDrawings {
    getProductDrawings {
      product_code
      pdf_url
      revit_url
      pdf_file_name
      revit_file_name
      pdf_download_url
    }
  }
`

export function useGetProductDrawingsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductDrawingsQuery, GetProductDrawingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProductDrawingsQuery, GetProductDrawingsQueryVariables>(GetProductDrawingsDocument, options)
}
export function useGetProductDrawingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductDrawingsQuery, GetProductDrawingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProductDrawingsQuery, GetProductDrawingsQueryVariables>(GetProductDrawingsDocument, options)
}
export type GetProductDrawingsQueryHookResult = ReturnType<typeof useGetProductDrawingsQuery>
export type GetProductDrawingsLazyQueryHookResult = ReturnType<typeof useGetProductDrawingsLazyQuery>
export type GetProductDrawingsQueryResult = Apollo.QueryResult<GetProductDrawingsQuery, GetProductDrawingsQueryVariables>

export type ProductInstructionAssignment = {
  __typename?: "ProductInstructionAssignment"
  product_code?: Maybe<Scalars["String"]["output"]>
  instruction_no?: Maybe<Scalars["String"]["output"]>
  instruction_desc?: Maybe<Scalars["String"]["output"]>
}

export type GetProductInstructionAssignmentsQueryVariables = Exact<{ [key: string]: never }>

export type GetProductInstructionAssignmentsQuery = {
  __typename?: "Query"
  getProductInstructionAssignments?: Array<{
    __typename?: "ProductInstructionAssignment"
    product_code?: string | null
    instruction_no?: string | null
    instruction_desc?: string | null
  } | null> | null
}

export const GetProductInstructionAssignmentsDocument = gql`
  query GetProductInstructionAssignments {
    getProductInstructionAssignments {
      product_code
      instruction_no
      instruction_desc
    }
  }
`

export function useGetProductInstructionAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProductInstructionAssignmentsQuery, GetProductInstructionAssignmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProductInstructionAssignmentsQuery, GetProductInstructionAssignmentsQueryVariables>(
    GetProductInstructionAssignmentsDocument,
    options
  )
}
export function useGetProductInstructionAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductInstructionAssignmentsQuery, GetProductInstructionAssignmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProductInstructionAssignmentsQuery, GetProductInstructionAssignmentsQueryVariables>(
    GetProductInstructionAssignmentsDocument,
    options
  )
}
export type GetProductInstructionAssignmentsQueryHookResult = ReturnType<typeof useGetProductInstructionAssignmentsQuery>
export type GetProductInstructionAssignmentsLazyQueryHookResult = ReturnType<typeof useGetProductInstructionAssignmentsLazyQuery>
export type GetProductInstructionAssignmentsQueryResult = Apollo.QueryResult<
  GetProductInstructionAssignmentsQuery,
  GetProductInstructionAssignmentsQueryVariables
>

export type DrawingsPageProduct = {
  __typename?: "DrawingsPageProduct"
  generic_code?: Maybe<Scalars["String"]["output"]>
  pdf_url?: Maybe<Scalars["String"]["output"]>
  revit_url?: Maybe<Scalars["String"]["output"]>
  pdf_file_name?: Maybe<Scalars["String"]["output"]>
  revit_file_name?: Maybe<Scalars["String"]["output"]>
  pdf_download_url?: Maybe<Scalars["String"]["output"]>
}

export type DrawingsPageCategory = {
  __typename?: "DrawingsPageCategory"
  group_name?: Maybe<Scalars["String"]["output"]>
  display_order?: Maybe<Scalars["Int"]["output"]>
  products?: Maybe<Array<Maybe<DrawingsPageProduct>>>
}

export type GetDrawingsPageDataQueryVariables = Exact<{ [key: string]: never }>

export type GetDrawingsPageDataQuery = {
  __typename?: "Query"
  getDrawingsPageData?: Array<{
    __typename?: "DrawingsPageCategory"
    group_name?: string | null
    display_order?: number | null
    products?: Array<{
      __typename?: "DrawingsPageProduct"
      generic_code?: string | null
      pdf_url?: string | null
      revit_url?: string | null
      pdf_file_name?: string | null
      revit_file_name?: string | null
      pdf_download_url?: string | null
    } | null> | null
  } | null> | null
}

export const GetDrawingsPageDataDocument = gql`
  query GetDrawingsPageData {
    getDrawingsPageData {
      group_name
      display_order
      products {
        generic_code
        pdf_url
        revit_url
        pdf_file_name
        revit_file_name
        pdf_download_url
      }
    }
  }
`

export function useGetDrawingsPageDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDrawingsPageDataQuery, GetDrawingsPageDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDrawingsPageDataQuery, GetDrawingsPageDataQueryVariables>(GetDrawingsPageDataDocument, options)
}
export function useGetDrawingsPageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDrawingsPageDataQuery, GetDrawingsPageDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDrawingsPageDataQuery, GetDrawingsPageDataQueryVariables>(GetDrawingsPageDataDocument, options)
}
export type GetDrawingsPageDataQueryHookResult = ReturnType<typeof useGetDrawingsPageDataQuery>
export type GetDrawingsPageDataLazyQueryHookResult = ReturnType<typeof useGetDrawingsPageDataLazyQuery>
export type GetDrawingsPageDataQueryResult = Apollo.QueryResult<GetDrawingsPageDataQuery, GetDrawingsPageDataQueryVariables>

export const ProductServicesByIdDocument = gql`
  query ProductServicesByID($productServicesByIdId: Int!) {
    productServicesByID(id: $productServicesByIdId) {
      header
      data {
        pid
        application
        element_grp {
          element_name
          services_grp {
            service_name
            service_size
            system_frl
            service_notes
            rep_grp {
              report_name
              report_url
              is_public
            }
          }
        }
      }
    }
  }
`

/**
 * __useProductServicesByIdQuery__
 *
 * To run a query within a React component, call `useProductServicesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductServicesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductServicesByIdQuery({
 *   variables: {
 *      productServicesByIdId: // value for 'productServicesByIdId'
 *   },
 * });
 */
export function useProductServicesByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>(ProductServicesByIdDocument, options)
}
export function useProductServicesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>(ProductServicesByIdDocument, options)
}
export function useProductServicesByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>(ProductServicesByIdDocument, options)
}
export type ProductServicesByIdQueryHookResult = ReturnType<typeof useProductServicesByIdQuery>
export type ProductServicesByIdLazyQueryHookResult = ReturnType<typeof useProductServicesByIdLazyQuery>
export type ProductServicesByIdSuspenseQueryHookResult = ReturnType<typeof useProductServicesByIdSuspenseQuery>
export type ProductServicesByIdQueryResult = Apollo.QueryResult<ProductServicesByIdQuery, ProductServicesByIdQueryVariables>
export const GetProductFilterCriteriaMasterDocument = gql`
  query GetProductFilterCriteriaMaster($criteria: ProductFilterInput) {
    getProductFilterCriteriaMaster(criteria: $criteria)
  }
`

/**
 * __useGetProductFilterCriteriaMasterQuery__
 *
 * To run a query within a React component, call `useGetProductFilterCriteriaMasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductFilterCriteriaMasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductFilterCriteriaMasterQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetProductFilterCriteriaMasterQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProductFilterCriteriaMasterQuery, GetProductFilterCriteriaMasterQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProductFilterCriteriaMasterQuery, GetProductFilterCriteriaMasterQueryVariables>(
    GetProductFilterCriteriaMasterDocument,
    options
  )
}
export function useGetProductFilterCriteriaMasterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductFilterCriteriaMasterQuery, GetProductFilterCriteriaMasterQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProductFilterCriteriaMasterQuery, GetProductFilterCriteriaMasterQueryVariables>(
    GetProductFilterCriteriaMasterDocument,
    options
  )
}
export function useGetProductFilterCriteriaMasterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductFilterCriteriaMasterQuery, GetProductFilterCriteriaMasterQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetProductFilterCriteriaMasterQuery, GetProductFilterCriteriaMasterQueryVariables>(
    GetProductFilterCriteriaMasterDocument,
    options
  )
}
export type GetProductFilterCriteriaMasterQueryHookResult = ReturnType<typeof useGetProductFilterCriteriaMasterQuery>
export type GetProductFilterCriteriaMasterLazyQueryHookResult = ReturnType<typeof useGetProductFilterCriteriaMasterLazyQuery>
export type GetProductFilterCriteriaMasterSuspenseQueryHookResult = ReturnType<typeof useGetProductFilterCriteriaMasterSuspenseQuery>
export type GetProductFilterCriteriaMasterQueryResult = Apollo.QueryResult<
  GetProductFilterCriteriaMasterQuery,
  GetProductFilterCriteriaMasterQueryVariables
>
export const ViewProfileDocument = gql`
  query ViewProfile($userId: Int!) {
    viewProfile(user_id: $userId) {
      user_id
      first_name
      last_name
      email_address
      company_name
      address1
      address2
      suburb
      city
      state
      pincode
      company_logo
      supplier
    }
  }
`

/**
 * __useViewProfileQuery__
 *
 * To run a query within a React component, call `useViewProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useViewProfileQuery(baseOptions: Apollo.QueryHookOptions<ViewProfileQuery, ViewProfileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ViewProfileQuery, ViewProfileQueryVariables>(ViewProfileDocument, options)
}
export function useViewProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProfileQuery, ViewProfileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ViewProfileQuery, ViewProfileQueryVariables>(ViewProfileDocument, options)
}
export function useViewProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewProfileQuery, ViewProfileQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ViewProfileQuery, ViewProfileQueryVariables>(ViewProfileDocument, options)
}
export type ViewProfileQueryHookResult = ReturnType<typeof useViewProfileQuery>
export type ViewProfileLazyQueryHookResult = ReturnType<typeof useViewProfileLazyQuery>
export type ViewProfileSuspenseQueryHookResult = ReturnType<typeof useViewProfileSuspenseQuery>
export type ViewProfileQueryResult = Apollo.QueryResult<ViewProfileQuery, ViewProfileQueryVariables>
export const ViewUserFmPsDocument = gql`
  query ViewUserFMPs($userId: Int!) {
    viewUserFMPs(user_id: $userId) {
      id
      user_id
      project_name
      project_address
      subcontractor_name
      subcontractor_address
      subcontractor_logo
      revision
      date_created
      date_modified
      systems
    }
  }
`

/**
 * __useViewUserFmPsQuery__
 *
 * To run a query within a React component, call `useViewUserFmPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUserFmPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUserFmPsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useViewUserFmPsQuery(baseOptions: Apollo.QueryHookOptions<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>(ViewUserFmPsDocument, options)
}
export function useViewUserFmPsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>(ViewUserFmPsDocument, options)
}
export function useViewUserFmPsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>(ViewUserFmPsDocument, options)
}
export type ViewUserFmPsQueryHookResult = ReturnType<typeof useViewUserFmPsQuery>
export type ViewUserFmPsLazyQueryHookResult = ReturnType<typeof useViewUserFmPsLazyQuery>
export type ViewUserFmPsSuspenseQueryHookResult = ReturnType<typeof useViewUserFmPsSuspenseQuery>
export type ViewUserFmPsQueryResult = Apollo.QueryResult<ViewUserFmPsQuery, ViewUserFmPsQueryVariables>
export const ViewUserArchivedFmPsDocument = gql`
  query ViewUserArchivedFMPs($userId: Int!) {
    viewUserArchivedFMPs(user_id: $userId) {
      id
      user_id
      project_name
      project_address
      subcontractor_name
      subcontractor_address
      subcontractor_logo
      revision
      date_created
      date_modified
      systems
    }
  }
`

/**
 * __useViewUserArchivedFmPsQuery__
 *
 * To run a query within a React component, call `useViewUserArchivedFmPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUserArchivedFmPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUserArchivedFmPsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useViewUserArchivedFmPsQuery(baseOptions: Apollo.QueryHookOptions<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>(ViewUserArchivedFmPsDocument, options)
}
export function useViewUserArchivedFmPsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>(ViewUserArchivedFmPsDocument, options)
}
export function useViewUserArchivedFmPsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>(ViewUserArchivedFmPsDocument, options)
}
export type ViewUserArchivedFmPsQueryHookResult = ReturnType<typeof useViewUserArchivedFmPsQuery>
export type ViewUserArchivedFmPsLazyQueryHookResult = ReturnType<typeof useViewUserArchivedFmPsLazyQuery>
export type ViewUserArchivedFmPsSuspenseQueryHookResult = ReturnType<typeof useViewUserArchivedFmPsSuspenseQuery>
export type ViewUserArchivedFmPsQueryResult = Apollo.QueryResult<ViewUserArchivedFmPsQuery, ViewUserArchivedFmPsQueryVariables>
export const GetProductMenuDocument = gql`
  query getProductMenu($category: Int!) {
    productMenu(category: $category)
  }
`

/**
 * __useGetProductMenuQuery__
 *
 * To run a query within a React component, call `useGetProductMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductMenuQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetProductMenuQuery(baseOptions: Apollo.QueryHookOptions<GetProductMenuQuery, GetProductMenuQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetProductMenuQuery, GetProductMenuQueryVariables>(GetProductMenuDocument, options)
}
export function useGetProductMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductMenuQuery, GetProductMenuQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetProductMenuQuery, GetProductMenuQueryVariables>(GetProductMenuDocument, options)
}
export function useGetProductMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductMenuQuery, GetProductMenuQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetProductMenuQuery, GetProductMenuQueryVariables>(GetProductMenuDocument, options)
}
export type GetProductMenuQueryHookResult = ReturnType<typeof useGetProductMenuQuery>
export type GetProductMenuLazyQueryHookResult = ReturnType<typeof useGetProductMenuLazyQuery>
export type GetProductMenuSuspenseQueryHookResult = ReturnType<typeof useGetProductMenuSuspenseQuery>
export type GetProductMenuQueryResult = Apollo.QueryResult<GetProductMenuQuery, GetProductMenuQueryVariables>
export const ProductByCodeDocument = gql`
  query ProductByCode($productCode: String!) {
    productByCode(productCode: $productCode) {
      id
      product_code
      product_desc
      generic_code
      product_category_id
      category_name
      installation_type_id
      installation_type
      nsz
      ht
      wd
      thick
      bd
      ind
      product_url
      product_qr_url
      pelements
      papplications
      pservices
      doc_grp {
        document_url
        document_type_id
        document_type
        display_order
        thumbnail_url
      }
    }
  }
`

/**
 * __useProductByCodeQuery__
 *
 * To run a query within a React component, call `useProductByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByCodeQuery({
 *   variables: {
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useProductByCodeQuery(baseOptions: Apollo.QueryHookOptions<ProductByCodeQuery, ProductByCodeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductByCodeQuery, ProductByCodeQueryVariables>(ProductByCodeDocument, options)
}
export function useProductByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByCodeQuery, ProductByCodeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductByCodeQuery, ProductByCodeQueryVariables>(ProductByCodeDocument, options)
}
export function useProductByCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductByCodeQuery, ProductByCodeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductByCodeQuery, ProductByCodeQueryVariables>(ProductByCodeDocument, options)
}
export type ProductByCodeQueryHookResult = ReturnType<typeof useProductByCodeQuery>
export type ProductByCodeLazyQueryHookResult = ReturnType<typeof useProductByCodeLazyQuery>
export type ProductByCodeSuspenseQueryHookResult = ReturnType<typeof useProductByCodeSuspenseQuery>
export type ProductByCodeQueryResult = Apollo.QueryResult<ProductByCodeQuery, ProductByCodeQueryVariables>
export const ProductServicesByCodeDocument = gql`
  query ProductServicesByCode($productCode: String!) {
    productServicesByCode(productCode: $productCode) {
      data {
        pid
        application
        element_grp {
          element_name
          services_grp {
            system_frl
            service_name
            service_notes
            service_size
            rep_grp {
              report_name
              report_url
              is_public
            }
          }
        }
      }
      header
    }
  }
`

/**
 * __useProductServicesByCodeQuery__
 *
 * To run a query within a React component, call `useProductServicesByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductServicesByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductServicesByCodeQuery({
 *   variables: {
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useProductServicesByCodeQuery(baseOptions: Apollo.QueryHookOptions<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>(ProductServicesByCodeDocument, options)
}
export function useProductServicesByCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>(ProductServicesByCodeDocument, options)
}
export function useProductServicesByCodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>(ProductServicesByCodeDocument, options)
}
export type ProductServicesByCodeQueryHookResult = ReturnType<typeof useProductServicesByCodeQuery>
export type ProductServicesByCodeLazyQueryHookResult = ReturnType<typeof useProductServicesByCodeLazyQuery>
export type ProductServicesByCodeSuspenseQueryHookResult = ReturnType<typeof useProductServicesByCodeSuspenseQuery>
export type ProductServicesByCodeQueryResult = Apollo.QueryResult<ProductServicesByCodeQuery, ProductServicesByCodeQueryVariables>
export const ReportPageDetailsDocument = gql`
  query reportPageDetails {
    reportDetails {
      reportNo
      reportURL
      fileName
      reportTypeId
      isPublic
    }
  }
`

/**
 * __useReportPageDetailsQuery__
 *
 * To run a query within a React component, call `useReportPageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPageDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportPageDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>(ReportPageDetailsDocument, options)
}
export function useReportPageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>(ReportPageDetailsDocument, options)
}
export function useReportPageDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>(ReportPageDetailsDocument, options)
}
export type ReportPageDetailsQueryHookResult = ReturnType<typeof useReportPageDetailsQuery>
export type ReportPageDetailsLazyQueryHookResult = ReturnType<typeof useReportPageDetailsLazyQuery>
export type ReportPageDetailsSuspenseQueryHookResult = ReturnType<typeof useReportPageDetailsSuspenseQuery>
export type ReportPageDetailsQueryResult = Apollo.QueryResult<ReportPageDetailsQuery, ReportPageDetailsQueryVariables>
export const GetReportDocument = gql`
  query GetReport($reportNo: String!) {
    getReport(report_no: $reportNo) {
      reportName
      reportURL
      downloadURL
      fileName
    }
  }
`

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      reportNo: // value for 'reportNo'
 *   },
 * });
 */
export function useGetReportQuery(baseOptions: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options)
}
export function useGetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options)
}
export function useGetReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options)
}
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>
export type GetReportSuspenseQueryHookResult = ReturnType<typeof useGetReportSuspenseQuery>
export type GetReportQueryResult = Apollo.QueryResult<GetReportQuery, GetReportQueryVariables>
export const GetInstallationInstructionReportDocument = gql`
  query GetInstallationInstructionReport($instruction: String!) {
    getInstallationInstructionReport(instruction: $instruction) {
      reportName
      reportURL
      downloadURL
      fileName
    }
  }
`

/**
 * __useGetInstallationInstructionReportQuery__
 *
 * To run a query within a React component, call `useGetInstallationInstructionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationInstructionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationInstructionReportQuery({
 *   variables: {
 *      instruction: // value for 'instruction'
 *   },
 * });
 */
export function useGetInstallationInstructionReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetInstallationInstructionReportQuery, GetInstallationInstructionReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInstallationInstructionReportQuery, GetInstallationInstructionReportQueryVariables>(
    GetInstallationInstructionReportDocument,
    options
  )
}
export function useGetInstallationInstructionReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInstallationInstructionReportQuery, GetInstallationInstructionReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInstallationInstructionReportQuery, GetInstallationInstructionReportQueryVariables>(
    GetInstallationInstructionReportDocument,
    options
  )
}
export function useGetInstallationInstructionReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetInstallationInstructionReportQuery, GetInstallationInstructionReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInstallationInstructionReportQuery, GetInstallationInstructionReportQueryVariables>(
    GetInstallationInstructionReportDocument,
    options
  )
}
export type GetInstallationInstructionReportQueryHookResult = ReturnType<typeof useGetInstallationInstructionReportQuery>
export type GetInstallationInstructionReportLazyQueryHookResult = ReturnType<typeof useGetInstallationInstructionReportLazyQuery>
export type GetInstallationInstructionReportSuspenseQueryHookResult = ReturnType<typeof useGetInstallationInstructionReportSuspenseQuery>
export type GetInstallationInstructionReportQueryResult = Apollo.QueryResult<
  GetInstallationInstructionReportQuery,
  GetInstallationInstructionReportQueryVariables
>
export const GetCertificateReportDocument = gql`
  query GetCertificateReport($certificateName: String!) {
    getCertificateReport(certificateName: $certificateName) {
      reportName
      reportURL
      fileName
    }
  }
`

/**
 * __useGetCertificateReportQuery__
 *
 * To run a query within a React component, call `useGetCertificateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateReportQuery({
 *   variables: {
 *      certificateName: // value for 'certificateName'
 *   },
 * });
 */
export function useGetCertificateReportQuery(baseOptions: Apollo.QueryHookOptions<GetCertificateReportQuery, GetCertificateReportQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCertificateReportQuery, GetCertificateReportQueryVariables>(GetCertificateReportDocument, options)
}
export function useGetCertificateReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateReportQuery, GetCertificateReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCertificateReportQuery, GetCertificateReportQueryVariables>(GetCertificateReportDocument, options)
}
export function useGetCertificateReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCertificateReportQuery, GetCertificateReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCertificateReportQuery, GetCertificateReportQueryVariables>(GetCertificateReportDocument, options)
}
export type GetCertificateReportQueryHookResult = ReturnType<typeof useGetCertificateReportQuery>
export type GetCertificateReportLazyQueryHookResult = ReturnType<typeof useGetCertificateReportLazyQuery>
export type GetCertificateReportSuspenseQueryHookResult = ReturnType<typeof useGetCertificateReportSuspenseQuery>
export type GetCertificateReportQueryResult = Apollo.QueryResult<GetCertificateReportQuery, GetCertificateReportQueryVariables>
export const FilterProductDocument = gql`
  query FilterProduct($criteria: ProductFilterInput) {
    filterProduct(criteria: $criteria)
  }
`

/**
 * __useFilterProductQuery__
 *
 * To run a query within a React component, call `useFilterProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterProductQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useFilterProductQuery(baseOptions?: Apollo.QueryHookOptions<FilterProductQuery, FilterProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FilterProductQuery, FilterProductQueryVariables>(FilterProductDocument, options)
}
export function useFilterProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterProductQuery, FilterProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FilterProductQuery, FilterProductQueryVariables>(FilterProductDocument, options)
}
export function useFilterProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FilterProductQuery, FilterProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FilterProductQuery, FilterProductQueryVariables>(FilterProductDocument, options)
}
export type FilterProductQueryHookResult = ReturnType<typeof useFilterProductQuery>
export type FilterProductLazyQueryHookResult = ReturnType<typeof useFilterProductLazyQuery>
export type FilterProductSuspenseQueryHookResult = ReturnType<typeof useFilterProductSuspenseQuery>
export type FilterProductQueryResult = Apollo.QueryResult<FilterProductQuery, FilterProductQueryVariables>
export const GetFmpSystemsProductsDocument = gql`
  query GetFmpSystemsProducts($systemIds: [Int!]!) {
    getFmpSystemsProducts(systemIds: $systemIds)
  }
`

/**
 * __useGetFmpSystemsProductsQuery__
 *
 * To run a query within a React component, call `useGetFmpSystemsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFmpSystemsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFmpSystemsProductsQuery({
 *   variables: {
 *      systemIds: // value for 'systemIds'
 *   },
 * });
 */
export function useGetFmpSystemsProductsQuery(
  baseOptions: Apollo.QueryHookOptions<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>(GetFmpSystemsProductsDocument, options)
}
export function useGetFmpSystemsProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>(GetFmpSystemsProductsDocument, options)
}
export function useGetFmpSystemsProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>(GetFmpSystemsProductsDocument, options)
}
export type GetFmpSystemsProductsQueryHookResult = ReturnType<typeof useGetFmpSystemsProductsQuery>
export type GetFmpSystemsProductsLazyQueryHookResult = ReturnType<typeof useGetFmpSystemsProductsLazyQuery>
export type GetFmpSystemsProductsSuspenseQueryHookResult = ReturnType<typeof useGetFmpSystemsProductsSuspenseQuery>
export type GetFmpSystemsProductsQueryResult = Apollo.QueryResult<GetFmpSystemsProductsQuery, GetFmpSystemsProductsQueryVariables>
export const ViewFmpProjectDocument = gql`
  query ViewFMPProject($userId: Int!, $fmpProjectId: Int!) {
    viewFMPProject(user_id: $userId, fmp_project_id: $fmpProjectId)
  }
`

/**
 * __useViewFmpProjectQuery__
 *
 * To run a query within a React component, call `useViewFmpProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewFmpProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewFmpProjectQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      fmpProjectId: // value for 'fmpProjectId'
 *   },
 * });
 */
export function useViewFmpProjectQuery(baseOptions: Apollo.QueryHookOptions<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>(ViewFmpProjectDocument, options)
}
export function useViewFmpProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>(ViewFmpProjectDocument, options)
}
export function useViewFmpProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>(ViewFmpProjectDocument, options)
}
export type ViewFmpProjectQueryHookResult = ReturnType<typeof useViewFmpProjectQuery>
export type ViewFmpProjectLazyQueryHookResult = ReturnType<typeof useViewFmpProjectLazyQuery>
export type ViewFmpProjectSuspenseQueryHookResult = ReturnType<typeof useViewFmpProjectSuspenseQuery>
export type ViewFmpProjectQueryResult = Apollo.QueryResult<ViewFmpProjectQuery, ViewFmpProjectQueryVariables>
export const ViewFmpProductDocument = gql`
  query viewFMPProduct($userId: Int!, $fmpProjectId: Int!, $fmpProductId: Int!) {
    viewFMPProduct(user_id: $userId, fmp_project_id: $fmpProjectId, fmp_product_id: $fmpProductId)
  }
`

/**
 * __useViewFmpProductQuery__
 *
 * To run a query within a React component, call `useViewFmpProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewFmpProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewFmpProductQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      fmpProjectId: // value for 'fmpProjectId'
 *      fmpProductId: // value for 'fmpProductId'
 *   },
 * });
 */
export function useViewFmpProductQuery(baseOptions: Apollo.QueryHookOptions<ViewFmpProductQuery, ViewFmpProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ViewFmpProductQuery, ViewFmpProductQueryVariables>(ViewFmpProductDocument, options)
}
export function useViewFmpProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewFmpProductQuery, ViewFmpProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ViewFmpProductQuery, ViewFmpProductQueryVariables>(ViewFmpProductDocument, options)
}
export function useViewFmpProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewFmpProductQuery, ViewFmpProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ViewFmpProductQuery, ViewFmpProductQueryVariables>(ViewFmpProductDocument, options)
}
export type ViewFmpProductQueryHookResult = ReturnType<typeof useViewFmpProductQuery>
export type ViewFmpProductLazyQueryHookResult = ReturnType<typeof useViewFmpProductLazyQuery>
export type ViewFmpProductSuspenseQueryHookResult = ReturnType<typeof useViewFmpProductSuspenseQuery>
export type ViewFmpProductQueryResult = Apollo.QueryResult<ViewFmpProductQuery, ViewFmpProductQueryVariables>
export const FaqsDocument = gql`
  query Faqs {
    faqs {
      id
      faq_q
      faq_a
      faq_image
      faq_information_reference
      display_order
    }
  }
`

/**
 * __useFaqsQuery__
 *
 * To run a query within a React component, call `useFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaqsQuery(baseOptions?: Apollo.QueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options)
}
export function useFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options)
}
export function useFaqsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options)
}
export type FaqsQueryHookResult = ReturnType<typeof useFaqsQuery>
export type FaqsLazyQueryHookResult = ReturnType<typeof useFaqsLazyQuery>
export type FaqsSuspenseQueryHookResult = ReturnType<typeof useFaqsSuspenseQuery>
export type FaqsQueryResult = Apollo.QueryResult<FaqsQuery, FaqsQueryVariables>
export const FrlStandardsDocument = gql`
  query FRLStandards {
    frlStandards
  }
`

/**
 * __useFrlStandardsQuery__
 *
 * To run a query within a React component, call `useFrlStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrlStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrlStandardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrlStandardsQuery(baseOptions?: Apollo.QueryHookOptions<FrlStandardsQuery, FrlStandardsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FrlStandardsQuery, FrlStandardsQueryVariables>(FrlStandardsDocument, options)
}
export function useFrlStandardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrlStandardsQuery, FrlStandardsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FrlStandardsQuery, FrlStandardsQueryVariables>(FrlStandardsDocument, options)
}
export function useFrlStandardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FrlStandardsQuery, FrlStandardsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FrlStandardsQuery, FrlStandardsQueryVariables>(FrlStandardsDocument, options)
}
export type FrlStandardsQueryHookResult = ReturnType<typeof useFrlStandardsQuery>
export type FrlStandardsLazyQueryHookResult = ReturnType<typeof useFrlStandardsLazyQuery>
export type FrlStandardsSuspenseQueryHookResult = ReturnType<typeof useFrlStandardsSuspenseQuery>
export type FrlStandardsQueryResult = Apollo.QueryResult<FrlStandardsQuery, FrlStandardsQueryVariables>
export const LogoutUserDocument = gql`
  mutation LogoutUser($userId: Int!) {
    logoutUser(user_id: $userId)
  }
`
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options)
}
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>
export const VerifyEmailDocument = gql`
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options)
}
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>
export const ResendVerificationLinkDocument = gql`
  mutation ResendVerificationLink($email_address: String!) {
    resendVerificationLink(email_address: $email_address)
  }
`
export type ResendVerificationLinkMutationFn = Apollo.MutationFunction<ResendVerificationLinkMutation, ResendVerificationLinkMutationVariables>

/**
 * __useResendVerificationLinkMutation__
 *
 * To run a mutation, you first call `useResendVerificationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationLinkMutation, { data, loading, error }] = useResendVerificationLinkMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useResendVerificationLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendVerificationLinkMutation, ResendVerificationLinkMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendVerificationLinkMutation, ResendVerificationLinkMutationVariables>(ResendVerificationLinkDocument, options)
}
export type ResendVerificationLinkMutationHookResult = ReturnType<typeof useResendVerificationLinkMutation>
export type ResendVerificationLinkMutationResult = Apollo.MutationResult<ResendVerificationLinkMutation>
export type ResendVerificationLinkMutationOptions = Apollo.BaseMutationOptions<
  ResendVerificationLinkMutation,
  ResendVerificationLinkMutationVariables
>
export const CreateFmpProjectDocument = gql`
  mutation CreateFMPProject($input: FMPProjectInput) {
    createFMPProject(input: $input)
  }
`
export type CreateFmpProjectMutationFn = Apollo.MutationFunction<CreateFmpProjectMutation, CreateFmpProjectMutationVariables>

/**
 * __useCreateFmpProjectMutation__
 *
 * To run a mutation, you first call `useCreateFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFmpProjectMutation, { data, loading, error }] = useCreateFmpProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFmpProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateFmpProjectMutation, CreateFmpProjectMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFmpProjectMutation, CreateFmpProjectMutationVariables>(CreateFmpProjectDocument, options)
}
export type CreateFmpProjectMutationHookResult = ReturnType<typeof useCreateFmpProjectMutation>
export type CreateFmpProjectMutationResult = Apollo.MutationResult<CreateFmpProjectMutation>
export type CreateFmpProjectMutationOptions = Apollo.BaseMutationOptions<CreateFmpProjectMutation, CreateFmpProjectMutationVariables>
export const DeleteFmpProjectDocument = gql`
  mutation DeleteFMPProject($deleteFmpProjectId: Int!, $deleteFmpProjectUserId: Int!) {
    deleteFMPProject(id: $deleteFmpProjectId, user_id: $deleteFmpProjectUserId)
  }
`
export type DeleteFmpProjectMutationFn = Apollo.MutationFunction<DeleteFmpProjectMutation, DeleteFmpProjectMutationVariables>

/**
 * __useDeleteFmpProjectMutation__
 *
 * To run a mutation, you first call `useDeleteFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFmpProjectMutation, { data, loading, error }] = useDeleteFmpProjectMutation({
 *   variables: {
 *      deleteFmpProjectId: // value for 'deleteFmpProjectId'
 *      deleteFmpProjectUserId: // value for 'deleteFmpProjectUserId'
 *   },
 * });
 */
export function useDeleteFmpProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFmpProjectMutation, DeleteFmpProjectMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFmpProjectMutation, DeleteFmpProjectMutationVariables>(DeleteFmpProjectDocument, options)
}
export type DeleteFmpProjectMutationHookResult = ReturnType<typeof useDeleteFmpProjectMutation>
export type DeleteFmpProjectMutationResult = Apollo.MutationResult<DeleteFmpProjectMutation>
export type DeleteFmpProjectMutationOptions = Apollo.BaseMutationOptions<DeleteFmpProjectMutation, DeleteFmpProjectMutationVariables>
export const ArchiveFmpProjectDocument = gql`
  mutation ArchiveFMPProject($archiveFmpProjectId: Int!, $archiveFmpProjectUserId: Int!, $archive: Boolean) {
    archiveFMPProject(id: $archiveFmpProjectId, user_id: $archiveFmpProjectUserId, archive: $archive)
  }
`
export type ArchiveFmpProjectMutationFn = Apollo.MutationFunction<ArchiveFmpProjectMutation, ArchiveFmpProjectMutationVariables>

/**
 * __useArchiveFmpProjectMutation__
 *
 * To run a mutation, you first call `useArchiveFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFmpProjectMutation, { data, loading, error }] = useArchiveFmpProjectMutation({
 *   variables: {
 *      archiveFmpProjectId: // value for 'archiveFmpProjectId'
 *      archiveFmpProjectUserId: // value for 'archiveFmpProjectUserId'
 *      archive: // value for 'archive'
 *   },
 * });
 */
export function useArchiveFmpProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveFmpProjectMutation, ArchiveFmpProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ArchiveFmpProjectMutation, ArchiveFmpProjectMutationVariables>(ArchiveFmpProjectDocument, options)
}
export type ArchiveFmpProjectMutationHookResult = ReturnType<typeof useArchiveFmpProjectMutation>
export type ArchiveFmpProjectMutationResult = Apollo.MutationResult<ArchiveFmpProjectMutation>
export type ArchiveFmpProjectMutationOptions = Apollo.BaseMutationOptions<ArchiveFmpProjectMutation, ArchiveFmpProjectMutationVariables>
export const AddToFmpProjectDocument = gql`
  mutation AddToFMPProject($input: FMPProductInput) {
    addToFMPProject(input: $input)
  }
`
export type AddToFmpProjectMutationFn = Apollo.MutationFunction<AddToFmpProjectMutation, AddToFmpProjectMutationVariables>

/**
 * __useAddToFmpProjectMutation__
 *
 * To run a mutation, you first call `useAddToFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToFmpProjectMutation, { data, loading, error }] = useAddToFmpProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddToFmpProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddToFmpProjectMutation, AddToFmpProjectMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddToFmpProjectMutation, AddToFmpProjectMutationVariables>(AddToFmpProjectDocument, options)
}
export type AddToFmpProjectMutationHookResult = ReturnType<typeof useAddToFmpProjectMutation>
export type AddToFmpProjectMutationResult = Apollo.MutationResult<AddToFmpProjectMutation>
export type AddToFmpProjectMutationOptions = Apollo.BaseMutationOptions<AddToFmpProjectMutation, AddToFmpProjectMutationVariables>
export const UpdateFmpProjectDocument = gql`
  mutation UpdateFMPProject($input: FMPProjectInput) {
    updateFMPProject(input: $input)
  }
`
export type UpdateFmpProjectMutationFn = Apollo.MutationFunction<UpdateFmpProjectMutation, UpdateFmpProjectMutationVariables>

/**
 * __useUpdateFmpProjectMutation__
 *
 * To run a mutation, you first call `useUpdateFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFmpProjectMutation, { data, loading, error }] = useUpdateFmpProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFmpProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFmpProjectMutation, UpdateFmpProjectMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFmpProjectMutation, UpdateFmpProjectMutationVariables>(UpdateFmpProjectDocument, options)
}
export type UpdateFmpProjectMutationHookResult = ReturnType<typeof useUpdateFmpProjectMutation>
export type UpdateFmpProjectMutationResult = Apollo.MutationResult<UpdateFmpProjectMutation>
export type UpdateFmpProjectMutationOptions = Apollo.BaseMutationOptions<UpdateFmpProjectMutation, UpdateFmpProjectMutationVariables>
export const RemoveFromFmpProjectDocument = gql`
  mutation RemoveFromFMPProject($input: FMPProductInput) {
    removeFromFMPProject(input: $input)
  }
`
export type RemoveFromFmpProjectMutationFn = Apollo.MutationFunction<RemoveFromFmpProjectMutation, RemoveFromFmpProjectMutationVariables>

/**
 * __useRemoveFromFmpProjectMutation__
 *
 * To run a mutation, you first call `useRemoveFromFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromFmpProjectMutation, { data, loading, error }] = useRemoveFromFmpProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFromFmpProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveFromFmpProjectMutation, RemoveFromFmpProjectMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveFromFmpProjectMutation, RemoveFromFmpProjectMutationVariables>(RemoveFromFmpProjectDocument, options)
}
export type RemoveFromFmpProjectMutationHookResult = ReturnType<typeof useRemoveFromFmpProjectMutation>
export type RemoveFromFmpProjectMutationResult = Apollo.MutationResult<RemoveFromFmpProjectMutation>
export type RemoveFromFmpProjectMutationOptions = Apollo.BaseMutationOptions<RemoveFromFmpProjectMutation, RemoveFromFmpProjectMutationVariables>
export const CopyFmpProjectDocument = gql`
  mutation CopyFMPProject($copyFmpProjectId: Int!, $userId: Int!, $projectName: String!) {
    copyFMPProject(id: $copyFmpProjectId, user_id: $userId, project_name: $projectName)
  }
`
export type CopyFmpProjectMutationFn = Apollo.MutationFunction<CopyFmpProjectMutation, CopyFmpProjectMutationVariables>

/**
 * __useCopyFmpProjectMutation__
 *
 * To run a mutation, you first call `useCopyFmpProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFmpProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFmpProjectMutation, { data, loading, error }] = useCopyFmpProjectMutation({
 *   variables: {
 *      copyFmpProjectId: // value for 'copyFmpProjectId'
 *      userId: // value for 'userId'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useCopyFmpProjectMutation(baseOptions?: Apollo.MutationHookOptions<CopyFmpProjectMutation, CopyFmpProjectMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CopyFmpProjectMutation, CopyFmpProjectMutationVariables>(CopyFmpProjectDocument, options)
}
export type CopyFmpProjectMutationHookResult = ReturnType<typeof useCopyFmpProjectMutation>
export type CopyFmpProjectMutationResult = Apollo.MutationResult<CopyFmpProjectMutation>
export type CopyFmpProjectMutationOptions = Apollo.BaseMutationOptions<CopyFmpProjectMutation, CopyFmpProjectMutationVariables>
export const EditFmpProductEntryDocument = gql`
  mutation EditFMPProductEntry($input: FMPProductEntryInput) {
    editFMPProductEntry(input: $input)
  }
`
export type EditFmpProductEntryMutationFn = Apollo.MutationFunction<EditFmpProductEntryMutation, EditFmpProductEntryMutationVariables>

/**
 * __useEditFmpProductEntryMutation__
 *
 * To run a mutation, you first call `useEditFmpProductEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFmpProductEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFmpProductEntryMutation, { data, loading, error }] = useEditFmpProductEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFmpProductEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<EditFmpProductEntryMutation, EditFmpProductEntryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditFmpProductEntryMutation, EditFmpProductEntryMutationVariables>(EditFmpProductEntryDocument, options)
}
export type EditFmpProductEntryMutationHookResult = ReturnType<typeof useEditFmpProductEntryMutation>
export type EditFmpProductEntryMutationResult = Apollo.MutationResult<EditFmpProductEntryMutation>
export type EditFmpProductEntryMutationOptions = Apollo.BaseMutationOptions<EditFmpProductEntryMutation, EditFmpProductEntryMutationVariables>
export const DownloadFmpReportsDocument = gql`
  mutation DownloadFMPReports($downloadFmpReportsId: Int!, $userId: Int!, $html: String!, $option: Int!) {
    downloadFMPReports(id: $downloadFmpReportsId, user_id: $userId, html: $html, option: $option)
  }
`
export type DownloadFmpReportsMutationFn = Apollo.MutationFunction<DownloadFmpReportsMutation, DownloadFmpReportsMutationVariables>

/**
 * __useDownloadFmpReportsMutation__
 *
 * To run a mutation, you first call `useDownloadFmpReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFmpReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFmpReportsMutation, { data, loading, error }] = useDownloadFmpReportsMutation({
 *   variables: {
 *      downloadFmpReportsId: // value for 'downloadFmpReportsId'
 *      userId: // value for 'userId'
 *      html: // value for 'html'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useDownloadFmpReportsMutation(
  baseOptions?: Apollo.MutationHookOptions<DownloadFmpReportsMutation, DownloadFmpReportsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DownloadFmpReportsMutation, DownloadFmpReportsMutationVariables>(DownloadFmpReportsDocument, options)
}
export type DownloadFmpReportsMutationHookResult = ReturnType<typeof useDownloadFmpReportsMutation>
export type DownloadFmpReportsMutationResult = Apollo.MutationResult<DownloadFmpReportsMutation>
export type DownloadFmpReportsMutationOptions = Apollo.BaseMutationOptions<DownloadFmpReportsMutation, DownloadFmpReportsMutationVariables>
export const ExportFmpToExcelDocument = gql`
  mutation ExportFMPToExcel($exportFmpToExcelId: Int!, $userId: Int!) {
    exportFMPToExcel(id: $exportFmpToExcelId, user_id: $userId)
  }
`
export type ExportFmpToExcelMutationFn = Apollo.MutationFunction<ExportFmpToExcelMutation, ExportFmpToExcelMutationVariables>

/**
 * __useExportFmpToExcelMutation__
 *
 * To run a mutation, you first call `useExportFmpToExcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportFmpToExcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportFmpToExcelMutation, { data, loading, error }] = useExportFmpToExcelMutation({
 *   variables: {
 *      exportFmpToExcelId: // value for 'exportFmpToExcelId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExportFmpToExcelMutation(baseOptions?: Apollo.MutationHookOptions<ExportFmpToExcelMutation, ExportFmpToExcelMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ExportFmpToExcelMutation, ExportFmpToExcelMutationVariables>(ExportFmpToExcelDocument, options)
}
export type ExportFmpToExcelMutationHookResult = ReturnType<typeof useExportFmpToExcelMutation>
export type ExportFmpToExcelMutationResult = Apollo.MutationResult<ExportFmpToExcelMutation>
export type ExportFmpToExcelMutationOptions = Apollo.BaseMutationOptions<ExportFmpToExcelMutation, ExportFmpToExcelMutationVariables>
export const ReOrderFmpProductsDocument = gql`
  mutation ReOrderFMPProducts($fmpProjectId: Int!, $userId: Int!, $input: [FMPProductOrder]) {
    reOrderFMPProducts(fmp_project_id: $fmpProjectId, user_id: $userId, input: $input)
  }
`
export type ReOrderFmpProductsMutationFn = Apollo.MutationFunction<ReOrderFmpProductsMutation, ReOrderFmpProductsMutationVariables>

/**
 * __useReOrderFmpProductsMutation__
 *
 * To run a mutation, you first call `useReOrderFmpProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReOrderFmpProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reOrderFmpProductsMutation, { data, loading, error }] = useReOrderFmpProductsMutation({
 *   variables: {
 *      fmpProjectId: // value for 'fmpProjectId'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReOrderFmpProductsMutation(
  baseOptions?: Apollo.MutationHookOptions<ReOrderFmpProductsMutation, ReOrderFmpProductsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReOrderFmpProductsMutation, ReOrderFmpProductsMutationVariables>(ReOrderFmpProductsDocument, options)
}
export type ReOrderFmpProductsMutationHookResult = ReturnType<typeof useReOrderFmpProductsMutation>
export type ReOrderFmpProductsMutationResult = Apollo.MutationResult<ReOrderFmpProductsMutation>
export type ReOrderFmpProductsMutationOptions = Apollo.BaseMutationOptions<ReOrderFmpProductsMutation, ReOrderFmpProductsMutationVariables>
